(ns capra.data
  "Client-side convenience functions for data ref operations.
   Thin wrappers over capra.core/call — return PendingRef inside pipe!,
   or Promise outside."
  (:require
   [capra.context :as ctx]
   [capra.stub :as stub]))

;; The actual call function is injected to avoid circular dependency
(defonce ^:private call-fn (atom nil))

(defn set-call-fn!
  "Set the call function. Called by capra.core during initialization."
  [f]
  (reset! call-fn f))

(defn- do-call [ctx data-ref method args]
  (if-let [f @call-fn]
    (f ctx data-ref method args)
    (throw (ex-info "capra.data: call-fn not initialized. Require capra.core first." {}))))

;; =============================================================================
;; Vector operations
;; =============================================================================

(defn dcount
  "Get the count of a data ref. Returns PendingRef in pipe!, Promise outside."
  [ctx data-ref]
  (do-call ctx data-ref :data/count {}))

(defn dslice
  "Get a slice of a vector data ref."
  [ctx data-ref start n]
  (do-call ctx data-ref :data/slice {:start start :count n}))

(defn dnth
  "Get the nth element of a vector data ref."
  [ctx data-ref idx]
  (do-call ctx data-ref :data/nth {:idx idx}))

;; =============================================================================
;; Map operations
;; =============================================================================

(defn dget
  "Get a value by key from a map data ref."
  [ctx map-ref key]
  (do-call ctx map-ref :data/get {:key key}))

(defn dkeys
  "Get the keys of a map data ref."
  [ctx map-ref]
  (do-call ctx map-ref :data/keys {}))

(defn dselect
  "Select specific keys from a map data ref."
  [ctx map-ref ks]
  (do-call ctx map-ref :data/select-keys {:keys ks}))

(defn dcontains?
  "Check if a map/set data ref contains a key/value."
  [ctx data-ref k]
  (do-call ctx data-ref :data/contains? {:key k}))

;; =============================================================================
;; Universal
;; =============================================================================

(defn drealize
  "Fetch the full collection from a data ref. Escape hatch."
  [ctx data-ref]
  (do-call ctx data-ref :data/realize {}))
